import createConverter from './lib/create_converter';
import AgentAssistanceConfig from 'models/agent_assistance_config';

export default createConverter(AgentAssistanceConfig);
